<template>
    <main class="max-width-container with-backdrop">
        <BackdropImage />
        <h1 class="form-title">Add trip</h1>
        <TripForm
            back-link="/trips"
            :errors="errors"
            @submit-form="submitForm"
            @clear-error="clearError"
        />
    </main>
</template>

<script>
import TripForm from "js/components/forms/TripForm";
import BackdropImage from "js/components/common/BackdropImage";
import BaseFormWrapper from "js/components/base/BaseFormWrapper.js";
import { useTripStore } from "js/stores/tripStore";
import { useUtilsStore } from "js/stores/utilsStore";
import { useUserStore } from "js/stores/userStore";

export default {
    name: "TripAdd",
    components: {
        TripForm,
        BackdropImage,
    },
    extends: BaseFormWrapper,
    data() {
        return {
            store: undefined,
            userStore: undefined,
            utilsStore: undefined,
            errors: {},
        };
    },
    async mounted() {
        this.store = useTripStore();
        this.utilsStore = useUtilsStore();
        this.userStore = useUserStore();
    },
    methods: {
        submitForm(trip) {
            this.store
                .create("/api/trips", trip, !!trip.user_image_file)
                .then(async (data) => {
                    this.store.add(data);
                    await this.userStore.refreshUser().catch(() => {});
                    this.$router.push(`/trips/${data.id}`);
                })
                .catch(this.handleResponseErrors);
            if (trip.companions) {
                this.utilsStore.invalidate("companions");
            }
        },
    },
};
</script>
